import { SvgIcon } from "@material-ui/core";

export const AtdpFileDownload = (props: any) => (
  <SvgIcon {...props} width="14" height="12" viewBox="0 0 11.529 14">
    <path id="Icon_material-file-download-2" data-name="Icon material-file-download" d="M19.029,9.441H15.735V4.5H10.794V9.441H7.5l5.765,5.765ZM7.5,16.853V18.5H19.029V16.853Z" transform="translate(-7.5 -4.5)" fill="#009bdd"/>
  </SvgIcon>
);
